import { withIcon } from "../Icon"

export const IconDocument = withIcon(
  '<path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M18.683 10.351v7.49a1.846 1.846 0 0 1-1.846 1.846H8.22a1.846 1.846 0 0 1-1.846-1.846V5.534a1.846 1.846 0 0 1 1.846-1.846h3.798c.326 0 .64.13.87.36l5.433 5.433c.231.23.36.544.36.87Z"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 3.969v4.219a1.125 1.125 0 0 0 1.125 1.124h4.219m-8.157 2.813h5.626m-5.626 2.813h5.626"/>',
)
